import Api from "../config/Axios";



export const postDashboardlist = async (token, user_id, data ) => {
  const config = {
    headers: {
      Authorization: "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get("api/web/tasks/zone-rider-order-stats?storeId="+data, config);
};

export const getRiderCurrentOrder = (token, user_id, data, storeID) => {
  const config = {
    headers: {
      Authorization:
      "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get("api/web/tasks/rider-stats?page="+(data.page ? data.page : 1)+"&limit="+(data.limit ? data.limit : 10)+"&store_id="+(storeID), config);
};

export const getRiderCurrentOrderV2 = (token, user_id, data, storeID) => {
  const config = {
    headers: {
      Authorization:
          "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get("api/web/tasks/rider-stats-v2?page="+(data.page ? data.page : 1)+"&limit="+(data.limit ? data.limit : 10)+"&zone_id="+(storeID), config);
};


export const getMetricsDashboard = (token, user_id, data) => {
  const config = {
    headers: {
      Authorization:
      "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/tasks/metrics-stats`, {params:data, ...config});
};

export const getShiftsList = (token, user_id, data) => {
  const config = {headers: {Authorization:"Bearer " + (token ? token : localStorage.getItem("token")), UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id"))}};
  return Api.get(`api/web/shifts-fill-rates`, {params:data, ...config});
};

export const getPickerPackerCountByStore = (token, user_id, storeId) => {
  const config = {
    headers: {
      Authorization: "Bearer " + (token ? token : localStorage.getItem("token")),
      UserId: parseInt(user_id ? user_id : localStorage.getItem("user_id")),
    },
  };
  return Api.get(`api/web/packmate/user-action/count-by-store/${storeId}`, config);
};
